// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ForgotPassword_componentWrapper__AM+N2","form":"ForgotPassword_form__x3jsW","actions":"ForgotPassword_actions__KITdr"};